<template>
  <div class="right">
    <span class="spen">{{ $t('common.My_order') }}</span>
    <div class="menu">
      <div class="daohang">
        <ul class="ul">
          <router-link :to="{ name: 'Dingdan' }" tag="li">{{ $t('common.Full_order') }}</router-link>
          <router-link :to="{ name: 'Fukuan' }" tag="li">{{ $t('common.due') }}</router-link>
          <router-link :to="{ name: 'Fahuo' }" tag="li">{{ $t('common.Goods_waiting_to_be_sent') }}</router-link>
          <router-link :to="{ name: 'Shouhuo' }" tag="li">{{ $t('common.Wait_to_be_received') }}</router-link>
          <router-link :to="{ name: 'Ping' }" tag="li">{{ $t('common.Remain_to_be_evaluated') }}</router-link>
          <router-link :to="{ name: 'Huishou' }" tag="li">{{ $t('common.Order_recycling_station') }}</router-link>
        </ul>
      </div>
      <Loading v-if="isLoading1" />
      <div class="search">
        <input type="text" v-model="mes" @keyup.enter.prevent="search" :placeholder="$t('placeholder.longmessage-004')" />
        <div class="fangdajing" @click="search">
          <img src="../../../assets/order/fangdajing.png" alt="" />
        </div>
      </div>
    </div>

    <div v-loading="isLoading">
      <div class="tishi" v-if="order_list == ''">{{ tishi }}</div>
      <div v-for="(item, index) in order_list" :key="index">
        <div class="top">
          <div class="biaoti">{{ item.createTime }}</div>
          <div class="biaoti mar">
            {{ $t('label.Order_number') }}：<span class="danhao">{{ item.orderNo }}</span>
          </div>
          <div class="biaoti mar dianpu" @click="dianpu(item)">
            {{ $t('common.shop') }}：{{ item.storeName }}
          </div>
          <!-- <div class="biaoti mar kefu">
            <span>客服</span><Uimage src="../../../assets/order/kefu.png" />
          </div> -->
        </div>
        <div class="bottom" v-for="(res, k) in item.orderSkuList" :key="k">
          <div class="pic">
            <Uimage :src="res.url" alt="" />
          </div>
          <div class="title1">
            <div class="title">
              <div class="miaoshu" @click="xiangqing(item.storeId, res.spuId)">
                {{ res.spuName }}
              </div>
              <div class="shuliang">X{{ res.skuCount }}</div>
            </div>
            <!-- 商品属性 -->
            <div class="shuxing" v-for="(q, c) in res.saleAttrCode" :key="c">
              <div v-if="q.attrName">{{ q.attrName }}：</div>
              <div v-if="q.attrValue" v-html="q.attrValue"></div>
            </div>
            <div class="shuxing">
              <div v-if="res.skuNum">{{ $t('common.Mark_number') }}：</div>
              <div v-if="res.skuNum" v-html="res.skuNum"></div>
            </div>
            <div class="shuxing">
              <div v-if="res.buyerNote">{{ $t('label.Product_remarks') }}：</div>
              <div v-if="res.buyerNote" v-html="res.buyerNote"></div>
            </div>
          </div>
          <div class="tousu">
            <span v-if="res.isTrue == 'true'">{{ $t('button.Complaint_seller') }}</span>
          </div>
          <div class="tousu">
            <span v-if="res.isTrue == 'true'">{{item.companyName}}</span>
          </div>
          <div class="price">
            <div class="jiage" v-if="item.orderSource == 4">
              {{ res.useScore }}
            </div>
            <div class="jiage" v-else>
              {{$t('currency.symbol')}}{{ Number(res.skuRealPrice * res.skuCount).toFixed(2) }}
            </div>
            <!-- <div class="yunfei">
              (含运费:￥{{ Number(res.freight).toFixed(2) }})
            </div> -->
            <div class="fangshi" v-if="item.orderSource == 4">{{ $t('button.Point_exchange') }}</div>
            <div class="fangshi" v-else>{{ $t('button.Online_payment') }}</div>
          </div>
          <div class="zhuangtai">
            <div v-if="item.orderStatus == 0 && res.isTrue == 'true'&&item.orderSource!=4">
              {{ $t('common.longmessage-005') }}
            </div>
            <div v-if="item.orderStatus == 0 && res.isTrue == 'true'&&item.orderSource==4">
               {{ $t('common.Waiting_for_buyer_to_redeem') }}
            </div>
            <div v-if="item.orderStatus == 1 && res.isTrue == 'true'">
              {{ $t('common.longmessage-006') }}
            </div>
            <div v-if="item.orderStatus == 2 && res.isTrue == 'true'">
              {{ $t('common.Wait_to_be_received') }}
            </div>
            <div v-if="item.applyStatus == 3"> {{ $t('common.Price_adjustment_request_denied') }}</div>
            <!--评价状态-->
            <div v-if="
                (item.orderStatus == 3 || item.orderStatus == 4) &&
                  res.isTrue == 'true'
              ">
              <div v-if="res.commentStatus == 0">
                {{ $t('common.Remain_to_be_evaluated') }}
              </div>
              <div v-if="res.commentStatus == 1">
                {{ $t('common.Buyer_evaluated') }}
              </div>
              <div v-if="res.commentStatus == 2">
                {{ $t('common.Seller_rated') }}
              </div>
              <div v-if="res.commentStatus == 3">
                {{ $t('common.Mutually_assessed') }}
              </div>
            </div>
            <div v-if="item.orderStatus == 4 && res.isTrue == 'true'">
              {{ $t('common.Successful_transaction') }}
            </div>
            <div v-if="item.orderStatus == 5 && res.isTrue == 'true'">
              {{ $t('common.Being_refunded') }}
            </div>
            <div v-if="item.orderStatus == 6 && res.isTrue == 'true'">
              {{ $t('common.Refunded') }}
            </div>
            <div v-if="item.orderStatus == 7 && res.isTrue == 'true'">
              {{ $t('common.Already_removed') }}
            </div>
            <div v-if="item.orderStatus == 10 && res.isTrue == 'true'">
              {{ $t('common.Cancelled') }}
            </div>
            <div v-if="item.orderStatus == 20 && res.isTrue == 'true'">
              {{ $t('common.Timeout_closing') }}
            </div>
            <div class="xiangqing" @click="ding_detail(res)" v-if="res.isTrue == 'true'">
              {{ $t('common.Order_details') }}
            </div>
            <div class="wuliu" v-if="
                (item.orderStatus == 2 ||
                  item.orderStatus == 3 ||
                  item.orderStatus == 4) &&
                  res.isTrue == 'true'
              " @click="wuliu(item)">
              {{ $t('button.View_logistics') }} 
            </div>
          </div>
          <div class="zhuangtai">
            <!--订单确认状态-->
            <div v-if="item.confirmStatus == 0 && res.isTrue == 'true'">
              {{ $t('common.To_be_confirmed') }}
            </div>
            <div v-if="item.confirmStatus == 1 && res.isTrue == 'true'">
              {{ $t('common.confirmed') }}
            </div>
          </div>
          <div class="pay">
            <div class="liji" v-if="item.orderStatus != 10 && item.orderSource != 4&& res.isStandardGas==1" @click="openAccessoriesList(item, res)">
              {{ $t('button.Accessory_management') }}
            </div>
            <div class="liji" v-if="item.orderStatus == 10&& item.orderSource != 4" @click="buy(item, res)">
              {{ $t('button.repurchase') }}
            </div>
            <!-- <div class="liji" v-if="item.orderStatus == 4" @click="buy(item, res)"> -->
            <div class="liji" v-if="item.applyStatus == 2&& item.orderSource != 4" @click="buy(item, res)">
              {{ $t('button.repurchase2') }}
            </div>
            <!-- v-if="item.orderStatus == 4"  -->
            <div class="liji1" v-if="item.orderStatus == 3 && res.commentStatus == 0" @click="pingjia(res)">
              {{ $t('button.Immediate_evaluation') }}
            </div>
            <div v-if="item.payBasic != null">
              <div class="liji" v-if="
                  item.orderStatus == 1 &&
                    item.payBasic.confirmStatus == '0' &&
                    item.payBasic.paymentModel == 'Pay-transfer'&&res.isTrue == 'true'
                " @click="updateVoucher(item)">
                {{ $t('button.longmessage-009') }}
              </div>
            </div>
            <div v-if="item.payBasic != null">
              <div class="liji" v-if="
                  item.orderStatus != 0 &&
                    item.payBasic.confirmStatus == '1' &&
                    item.payBasic.paymentModel == 'Pay-transfer'
                " @click="lookVoucher(item)">
                {{ $t('button.longmessage-010') }}
              </div>
            </div>
            <!--以下操作可合并-->
            <div class="queren" v-if="
                item.managerId != null && item.applyStatus != '1' && item.applyStatus != '3' &&
                  item.confirmStatus == 0 &&
                  res.isTrue == 'true'
              " @click="lijiconfirm(item)">
              {{ $t('button.Immediate_confirmation') }}
            </div>
            <div class="liji" v-if="
                item.orderStatus == 0 &&
                  item.applyStatus != 1 &&
                  res.isTrue == 'true' && item.orderSource == 4
              " @click="fukuan2(item)">
              {{ $t('button.Redeem_now') }}
            </div>
            <div class="liji" v-if="
                item.orderStatus == 0 &&
                  item.applyStatus != 1 &&
                  res.isTrue == 'true' && item.orderSource != 4
              " @click="fukuan(item)">
              {{ $t('button.Immediate_payment') }}
            </div>
            <div class="liji" v-if="item.orderStatus != 10 && res.isTrue == 'true'&&item.orderSource!=4" @click="showCertList(item, res)">
              {{ $t('button.View_Certificate_list') }}
            </div>
            <div class="shachu" v-if="item.orderStatus == 0 && res.isTrue == 'true'" @click="quxiao(item)">
              {{ $t('button.Cancel_an_order') }}
            </div>
            <div class="liji1" v-if="item.orderStatus == 2 && res.isTrue == 'true'" @click="shouhuo(item)">
              {{ $t('button.Confirm_receipt_of_goods') }}
            </div>
            <div class="fapiaoshenqing" @click="applyInvoice(item)" v-if="
                ((item.orderStatus == 3 &&
                  (item.orderExt.needInv == 0 ||
                    item.orderExt.needInv == null)) ||
                  (item.orderStatus == 4 &&
                    (item.orderExt.needInv == 0 ||
                      item.orderExt.needInv == null))) &&
                  res.isTrue == 'true'
              ">
              {{ $t('button.Apply_for_invoice') }}
            </div>
            <div class="fapiaochakan" @click="showInvoice(item)" v-if="
                ((item.orderStatus == 3 && item.orderExt.needInv == 2) ||
                  (item.orderStatus == 4 && item.orderExt.needInv == 2)) &&
                  res.isTrue == 'true'
              ">
              {{ $t('button.Check_the_invoice') }}
            </div>
            <div class="fapiaoshenqingzhong" v-if="
                ((item.orderStatus == 3 && item.orderExt.needInv == 1) ||
                  (item.orderStatus == 4 && item.orderExt.needInv == 1)) &&
                  res.isTrue == 'true'
              ">
              {{ $t('common.Invoice_application') }}
            </div>
          </div>
        </div>

        <!-- 分页 -->
      </div>
      <div class="fenye" v-if="order_list != ''">
        <el-pagination @current-change="pagechange" :current-page="page.current"
          style="text-align: right;margin-top: 20px" background :total="page.total" :page-size="page.size"
          layout="prev, pager, next, jumper, ->, total">
        </el-pagination>
      </div>

      <el-dialog :title="$t('common.Material_flow')" :visible.sync="dialogFormVisible">
        <div class="block">
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in wuliu_list" :key="index" :timestamp="activity.time"
              :color="activity.ftime">
              {{ activity.context }}
            </el-timeline-item>
          </el-timeline>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">{{ $t('button.Cancel') }}</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="$t('label.New_invoice_title')" :visible.sync="dialogVisible">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label-width="400px">
            <span slot="label"><span style="color: #f56c6c;font-size: 14px;">
              {{ $t('message.longmessage-012') }}
              </span></span>
          </el-form-item>
          <el-form-item v-show="false" :label="$t('label.Order_number2')" label-width="100px" prop="orderId">
            <el-input v-model="form.orderId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('label.Invoice_type')" label-width="100px" prop="invType">
            <el-select v-model="form.invType" :placeholder="$t('label.Invoice_type')">
              <el-option :label="$t('label.Electronic_ordinary_invoice')" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('label.Invoice_content')" label-width="100px" prop="region">
            <el-select v-model="form.region" :placeholder="$t('label.Invoice_content')">
              <el-option :label="$t('label.detail')" value="mx"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('label.Header_type')" label-width="100px" prop="ivcTitleType">
            <el-select v-model="form.ivcTitleType" :placeholder="$t('label.Header_type')">
              <el-option :label="$t('label.personage')" value="0"></el-option>
              <el-option :label="$t('label.firm')" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('label.Invoice_title')" label-width="100px" prop="invTitle">
            <el-input v-model="form.invTitle"></el-input>
          </el-form-item>
          <el-form-item v-if="form.ivcTitleType == '1'" :label="$t('label.Duty_number')" label-width="100px" prop="registCode">
            <el-input v-model="form.registCode"></el-input>
          </el-form-item>
          <el-form-item v-if="form.ivcTitleType == '1'" :label="$t('label.Bank_of_deposit')" label-width="100px" prop="registBank">
            <el-input v-model="form.registBank"></el-input>
          </el-form-item>
          <el-form-item v-if="form.ivcTitleType == '1'" :label="$t('label.Bank_account_number')" label-width="100px" prop="bankAccount">
            <el-input v-model="form.bankAccount"></el-input>
          </el-form-item>
          <el-form-item v-if="form.ivcTitleType == '1'" :label="$t('label.Enterprise_address')" label-width="100px" prop="registAddress">
            <el-input v-model="form.registAddress"></el-input>
          </el-form-item>
          <el-form-item v-if="form.ivcTitleType == '1'" :label="$t('label.Enterprise_telephone')" label-width="100px" prop="registPhone">
            <el-input v-model="form.registPhone"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ $t('button.Cancel') }}</el-button>
          <el-button type="primary" @click="submitForm('form')">{{ $t('button.Confirm') }}</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="$t('common.shortmessage-005')" :visible.sync="dialogVisible1" width="40%" :before-close="handleClose">
        <el-form ref="formdata" :model="formdata" label-width="140px" :rules="rules">
          <el-form-item :label="$t('label.Transaction_number')" prop="payRemittanceId">
            <el-input v-model="formdata.payRemittanceId"></el-input>
          </el-form-item>
          <el-form-item :label="$t('label.Name_of_payer')" prop="payerName">
            <el-input v-model="formdata.payerName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('label.Payment_account_number')" prop="payerCardNumber">
            <el-input v-model="formdata.payerCardNumber"></el-input>
          </el-form-item>
          <el-form-item :label="$t('label.Payment_summary')" prop="paymentSummary">
            <el-input v-model="formdata.paymentSummary"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.shortmessage-027')" prop="imageUrl">
            <el-upload class="avatar-uploader" :action="picurl" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" list-type="picture-card">
              <Uimage v-if="formdata.imageUrl" :src="formdata.imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible1 = false">{{ $t('button.Cancel') }}</el-button>
          <el-button type="primary" @click="confirm('formdata')">{{ $t('button.Confirm') }}</el-button>
        </span>
      </el-dialog>
      <el-dialog :title="$t('common.shortmessage-005')" :visible.sync="dialogVisible2" width="40%" :before-close="handleClose">
        <el-form ref="formdata1" :model="formdata1" label-width="140px">
          <el-form-item :label="$t('label.Transaction_number')">
            <el-input v-model="formdata1.payRemittanceId" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('label.Name_of_payer')">
            <el-input v-model="formdata1.payerName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('label.Payment_account_number')">
            <el-input v-model="formdata1.payerCardNumber" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('label.Payment_summary')">
            <el-input v-model="formdata1.paymentSummary" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.shortmessage-027')">
            <Uimage :src="formdata1.imageUrl" class="avatar" />
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">{{ $t('button.Cancel') }}</el-button>
        </span>
      </el-dialog>
      <cert_list ref="certList" />
      <!-- 配件列表 -->
      <accessoriesList ref="accessoriesForm" />
    </div>
  </div>
</template>
<script>
  import {
    post,
    get
  } from '@/utils/request';
  import {
    setContextData,
    getContextData
  } from '../../../utils/session.js';
  import {
    confirmOrder
  } from '@/utils/pageUtils.js';
  import {
    submitOrderTemp
  } from '@/api/order.js';
  import {
    openPay
  } from '@/utils/pageUtils.js';
  import {
    baseURL
  } from '@/utils/request';
  import cert_list from './cert-list';
  import accessoriesList from './accessoriesList';
  export default {
    components: {
      cert_list,
      accessoriesList
    },
    data() {
      return {
        order_list: [],
        isLoading: true,
        isLoading1: false,
        mes: '',
        tishi: this.$t('common.Its_empty'),
        currentPage: 1,
        totalNum: 1,
        wuliu_list: [],
        dialogFormVisible: false,
        dialogVisible: false,
        page: {
          total: 1,
          size: 10,
          current: 1,
        },
        form: {
          orderId: '',
          invType: '',
          region: '',
          ivcTitleType: '',
          invTitle: '',
          registCode: '',
          registBank: '',
          bankAccount: '',
          registAddress: '',
          registPhone: '',
        },
        formdata: {
          payRemittanceId: '',
          payerName: '',
          payerCardNumber: '',
          paymentSummary: '',
          imageUrl: '',
        },
        formdata1: {
          payRemittanceId: '',
          payerName: '',
          payerCardNumber: '',
          paymentSummary: '',
          imageUrl: '',
        },
        picurl: baseURL + 'f/api/frontCommon/payVoucher',
        coverImg: '',
        orderId: '',
        imageUrl: '',
        rules: {
          invTitle: [{
            required: true,
            message: this.$t('message.longmessage-011'),
            trigger: 'blur'
          }, ],
          registCode: [{
            required: true,
            message: this.$t('message.shortmessage-028'),
            trigger: 'blur'
          }, ],
          payRemittanceId: [{
              required: true,
              message: this.$t('message.shortmessage-029'),
              trigger: 'blur'
            },
            {
              min: 1,
              max: 100,
              message: this.$t('message.shortmessage-008'),
              trigger: 'blur',
            },
          ],
          payerName: [{
              required: true,
              message: this.$t('message.shortmessage-006'),
              trigger: 'blur'
            },
            {
              min: 1,
              max: 100,
              message: this.$t('message.shortmessage-008'),
              trigger: 'blur',
            },
          ],
          payerCardNumber: [{
              required: true,
              message: this.$t('message.shortmessage-007'),
              trigger: 'blur'
            },
            {
              min: 1,
              max: 50,
              message: this.$t('message.shortmessage-009'),
              trigger: 'blur',
            },
          ],
          paymentSummary: [{
              required: true,
              message: this.$t('message.shortmessage-030'),
              trigger: 'blur'
            },
            {
              min: 1,
              max: 100,
              message: this.$t('message.shortmessage-008'),
              trigger: 'blur',
            },
          ],
          imageUrl: [{
            required: true,
            message: this.$t('message.shortmessage-027'),
            trigger: 'blur'
          }, ],
        },
        dialogVisible1: false,
        dialogVisible2: false,
      };
    },
    created() {
      this.currentPage = getContextData('currentPage') || 1;
      this.getorder(this.currentPage);
    },
    methods: {
      updateVoucher(e) {
        this.formdata.payRemittanceId = e.payBasic.payRemittanceId;
        this.formdata.payerName = e.payBasic.payerName;
        this.formdata.payerCardNumber = e.payBasic.payerCardNumber;
        this.formdata.paymentSummary = e.payBasic.paymentSummary;
        this.formdata.imageUrl = e.payBasic.paymentVoucher;
        this.orderId = e.payBasic.orderId;
        this.dialogVisible1 = true;
      },
      lookVoucher(e) {
        this.formdata1.payRemittanceId = e.payBasic.payRemittanceId;
        this.formdata1.payerName = e.payBasic.payerName;
        this.formdata1.payerCardNumber = e.payBasic.payerCardNumber;
        this.formdata1.paymentSummary = e.payBasic.paymentSummary;
        this.formdata1.imageUrl = e.payBasic.paymentVoucher;
        this.dialogVisible2 = true;
      },
      confirm(formdata) {
        this.$refs[formdata].validate((valid) => {
          if (valid) {
            post('api/orderbasic/updatePayBasic', {
              paymentVoucher: this.coverImg,
              orderId: this.orderId,
              paymentAmount: this.sumPrice,
              payRemittanceId: this.formdata.payRemittanceId,
              payerName: this.formdata.payerName,
              payerCardNumber: this.formdata.payerCardNumber,
              paymentSummary: this.formdata.paymentSummary,
            }).then((res) => {
              this.dialogVisible1 = false;
              this.getorder(this.currentPage);
            });
          } else {
            return false;
          }
        });
      },
      handleClose(done) {
        this.$confirm(this.$t('message.confirm.Confirm_closure'))
          .then((_) => {
            done();
          })
          .catch((_) => {});
      },
      handleAvatarSuccess(res, file) {
        this.coverImg = res.fileName;
        this.formdata.imageUrl = res.url;
      },
      beforeAvatarUpload(file) {
        const isJPG =
          file.type === 'image/jpeg' ||
          'image/jpg' ||
          'image/webp' ||
          'image/png';
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error({
            message: this.$t('message.shortmessage-011'),
          });
        }
        if (!isLt2M) {
          this.$message.error({
            message: this.$t('message.shortmessage-012'),
          });
        }
        return isJPG && isLt2M;
      },
      xiangqing(storeId, spuId) {
        const {
          href
        } = this.$router.resolve({
          name: 'detail',
          params: {
            //店铺id
            storeId: storeId,
            //商品id
            spu: spuId,
          },
        });
        window.open(href, '_blank');
      },
      //店铺
      dianpu(e) {
        const {
          href
        } = this.$router.resolve({
          name: 'store_index',
          params: {
            storeId: e.storeId,
          },
        });
        window.open(href, '_blank');
      },
      //再次购买 重新购买
      buy(item, res) {
        // 根据批次号获取订单商品sku明细信息集合
         get('api/orderbasic/getOrderSkuListByBatchNumber?batchNumber='+res.batchNumber).then(
          (res) => {
            let orderTemp = [];
            res.data.data.forEach((req) => {
              orderTemp.push({
                skuId: req.skuId,
                num: req.skuCount,
                value: req.value,
                storeId: item.storeId,
                remark: 1,
              });
            })
            // 提交临时订单
            submitOrderTemp(orderTemp).then((res) => {
              confirmOrder();
            });
          })
      },
      //查看证书列表 order_sku_id
      showCertList(item, req) {
        //打开证书页面
        this.isLoading = false;
        this.$refs.certList.orderSkuId = req.orderSkuId;
        this.$refs.certList.orderNo = item.orderNo;
        this.$refs.certList.orderId = item.orderId;
        this.$refs.certList.initData();
        this.$refs.certList.dialogTableVisible = true;
        this.$refs.certList.loading = true;
      },
      // 查看证书
      showCert(item, req) {
        post('api/cert/createPDFCert', {
          orderId: req.orderId,
          orderNo: item.orderNo,
          spuId: req.spuId,
          spuName: req.spuName,
          skuId: req.skuId,
          skuName: req.skuName
        }).then((res) => {
          if (res.data.data.certUrl == '' || res.data.data.certUrl == null) {
            this.$message.warning({
              message: this.$t('message.shortmessage-031'),
            });
          } else {
            // 跳转在线预览证书pdf页面
            const {
              href
            } = this.$router.resolve({
              name: 'CertPDF',
              params: {
                //店铺id
                certUrl: res.data.data.certUrl
              },
            });
            console.log(href)
            window.open(href, '_blank');
          }
        })
      },
      wuliu(e) {
        this.isLoading1 = true;
        get(
          'api/orderexpress/getorderexpress?com=' +
          e.orderExt.expressId +
          '&num=' +
          e.orderExt.expressNum +
          ''
        ).then((res) => {
          if (
            res.data.data.returnCode == undefined ||
            res.data.data.status == 200
          ) {
            res.data.data.data[0].ftime = '#0bbd87';
            this.wuliu_list = res.data.data.data;
            this.isLoading1 = false;
            this.dialogFormVisible = true;
          } else {
            this.isLoading1 = false;
            this.$message.warning({
              message: res.data.data.message,
            });
          }
        });
      },
      pagechange(p) {
        this.isLoading = true;
        this.page.current = p;
        setContextData('currentPage', this.currentPage);
        get(
          'api/orderbasic/getOrderByMemberId?pageNum=' + p + '&pageSize=10'
        ).then((res) => {
          res.data.data.list.forEach((req) => {
            if (req.orderSource == 4) {
              req.orderSkuList[0].skuRealPrice = 0;
            }
            req.orderSkuList.forEach((q) => {
              q.saleAttrCode = eval('(' + q.saleAttrCode + ')');
              if (q.value != '0mol/mol' && q.value != '0ppm' && q.value != null) {
                if (q.value.indexOf('mol/mol') != -1) {
                  q.saleAttrCode.push({
                    attrName: this.$t('common.Confirmed_content'),
                    attrValue: q.value.replace(
                      'mol/mol',
                      'X10<sup>-6</sup>mol/mol'
                    ),
                  });
                } else {
                  q.saleAttrCode.push({
                    attrName: this.$t('common.Confirmed_content'),
                    attrValue: q.value,
                  });
                }
              }
              q.saleAttrCode.forEach((k, index) => {
                if (k.attrName == '浓度范围'||k.attrName == 'Concentration Range') {
                  q.saleAttrCode.splice(index, 1);
                }
              });
              Object.assign(q, {
                isTrue: 'false'
              });

            });
            for (let q = 0; q < req.orderSkuList.length; q++) {
              for (let j = q + 1; j < req.orderSkuList.length; j++) {
                if (req.orderSkuList[q].remark == '1' && req.orderSkuList[j].remark == '1') {
                  if (req.orderSkuList[q].skuName == req.orderSkuList[j].skuName && req.orderSkuList[q]
                    .storeId == req.orderSkuList[j].storeId && req.orderSkuList[q].prodCatId == req
                    .orderSkuList[j].prodCatId && req.orderSkuList[q].batchNumber == req.orderSkuList[j]
                    .batchNumber) {
                    for (
                      let p = 0; p < req.orderSkuList[j].saleAttrCode.length; p++
                    ) {
                      if (
                        req.orderSkuList[j].saleAttrCode[p].attrName == '多组分' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == 'Multicomponent' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == '气体组分' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == 'Gas Components' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == '确认含量' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == 'Confirmed content'
                      ) {
                        req.orderSkuList[q].saleAttrCode.push(
                          req.orderSkuList[j].saleAttrCode[p]
                        );
                      }
                    }
                  }
                }
              }
            }
            req.orderSkuList[0].isTrue = 'true';
          });
          res.data.data.list.forEach((i) => {
            for (let q = 0; q < i.orderSkuList.length; q++) {
              for (let j = q + 1; j < i.orderSkuList.length; j++) {
                if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                  if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                    .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId && i
                    .orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                    i.orderSkuList.splice(j, 1);
                  }
                }
              }
            }
          })
          res.data.data.list.forEach((i) => {
            for (let q = 0; q < i.orderSkuList.length; q++) {
              for (let j = q + 1; j < i.orderSkuList.length; j++) {
                if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                  if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                    .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId && i
                    .orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                    i.orderSkuList.splice(j, 1);
                  }
                }
              }
            }
          })
          res.data.data.list.forEach((i) => {
            for (let q = 0; q < i.orderSkuList.length; q++) {
              for (let j = q + 1; j < i.orderSkuList.length; j++) {
                if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                  if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                    .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId && i
                    .orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                    i.orderSkuList.splice(j, 1);
                  }
                }
              }
            }
          })
          this.order_list = res.data.data.list;
        }).finally(() => {
				  this.isLoading = false;
			  });
      },
      getorder(e) {
        this.isLoading = true;
        get(
          'api/orderbasic/getOrderByMemberId?pageNum=' + e + '&pageSize=10'
        ).then((res) => {
          this.isLoading = false;
          res.data.data.list.forEach((req) => {
            if (req.orderSource == 4) {
              req.orderSkuList[0].skuRealPrice = 0;
            }
            req.orderSkuList.forEach((q) => {
              q.saleAttrCode = eval('(' + q.saleAttrCode + ')');
              if (q.value != '0mol/mol' && q.value != '0ppm' && q.value != null) {
                if (q.value.indexOf('mol/mol') != -1) {
                  q.saleAttrCode.push({
                    attrName: this.$t('common.Confirmed_content'),
                    attrValue: q.value.replace(
                      'mol/mol',
                      'X10<sup>-6</sup>mol/mol'
                    ),
                  });
                } else {
                  q.saleAttrCode.push({
                    attrName: this.$t('common.Confirmed_content'),
                    attrValue: q.value,
                  });
                }
              }
              q.saleAttrCode.forEach((k, index) => {
                if (k.attrName == '浓度范围'||k.attrName == 'Concentration Range') {
                  q.saleAttrCode.splice(index, 1);
                }
              });
              Object.assign(q, {
                isTrue: 'false'
              });
            });

            for (let q = 0; q < req.orderSkuList.length; q++) {
              for (let j = q + 1; j < req.orderSkuList.length; j++) {
                if (req.orderSkuList[q].remark == '1' && req.orderSkuList[j].remark == '1') {
                  if (req.orderSkuList[q].skuName == req.orderSkuList[j].skuName && req.orderSkuList[q]
                    .storeId == req.orderSkuList[j].storeId && req.orderSkuList[q].prodCatId == req
                    .orderSkuList[j].prodCatId && req.orderSkuList[q].batchNumber == req.orderSkuList[j]
                    .batchNumber) {
                    for (
                      let p = 0; p < req.orderSkuList[j].saleAttrCode.length; p++
                    ) {
                      if (
                        req.orderSkuList[j].saleAttrCode[p].attrName == '多组分' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == 'Multicomponent' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == '气体组分' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == 'Gas Components' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == '确认含量' ||
                        req.orderSkuList[j].saleAttrCode[p].attrName == 'Confirmed content'
                      ) {
                        req.orderSkuList[q].saleAttrCode.push(
                          req.orderSkuList[j].saleAttrCode[p]
                        );
                      }
                    }
                  }
                }
              }
            }
            req.orderSkuList[0].isTrue = 'true';
          });
          res.data.data.list.forEach((i) => {
            for (let q = 0; q < i.orderSkuList.length; q++) {
              for (let j = q + 1; j < i.orderSkuList.length; j++) {
                if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                  if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                    .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId && i
                    .orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                    i.orderSkuList.splice(j, 1);
                  }
                }
              }
            }
          })
          res.data.data.list.forEach((i) => {
            for (let q = 0; q < i.orderSkuList.length; q++) {
              for (let j = q + 1; j < i.orderSkuList.length; j++) {
                if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                  if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                    .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId && i
                    .orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                    i.orderSkuList.splice(j, 1);
                  }
                }
              }
            }
          })
          res.data.data.list.forEach((i) => {
            for (let q = 0; q < i.orderSkuList.length; q++) {
              for (let j = q + 1; j < i.orderSkuList.length; j++) {
                if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                  if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                    .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId && i
                    .orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                    i.orderSkuList.splice(j, 1);
                  }
                }
              }
            }
          })
          this.order_list = res.data.data.list;
          this.page.total = res.data.data.total;
        });
      },
      search() {
        this.isLoading = true;
        get('api/orderbasic/getOrderByMemberId?orderNo=' + this.mes).then(
          (res) => {
            if (res.data.data.list == '') {
              this.tishi = this.$t('message.No_order_found');
              res.data.data.list.forEach((req) => {
                if (req.orderSource == 4) {
                  req.orderSkuList[0].skuRealPrice = 0;
                }
              });
              this.order_list = res.data.data.list;
            } else {
              res.data.data.list.forEach((req) => {
                if (req.orderSource == 4) {
                  req.orderSkuList[0].skuRealPrice = 0;
                }
                req.orderSkuList.forEach((q) => {
                  q.saleAttrCode = eval('(' + q.saleAttrCode + ')');
                  if (q.value != '0mol/mol' && q.value != '0ppm' && q.value != null) {
                    if (q.value.indexOf('mol/mol') != -1) {
                      q.saleAttrCode.push({
                        attrName: this.$t('common.Confirmed_content'),
                        attrValue: q.value.replace(
                          'mol/mol',
                          'X10<sup>-6</sup>mol/mol'
                        ),
                      });
                    } else {
                      q.saleAttrCode.push({
                        attrName: this.$t('common.Confirmed_content'),
                        attrValue: q.value,
                      });
                    }
                  }
                  q.saleAttrCode.forEach((k, index) => {
                    if (k.attrName == '浓度范围'||k.attrName == 'Concentration Range') {
                      q.saleAttrCode.splice(index, 1);
                    }
                  });
                  Object.assign(q, {
                    isTrue: 'false'
                  });
                });
                for (let q = 0; q < req.orderSkuList.length; q++) {
                  for (let j = q + 1; j < req.orderSkuList.length; j++) {
                    if (req.orderSkuList[q].remark == '1' && req.orderSkuList[j].remark == '1') {
                      if (req.orderSkuList[q].skuName == req.orderSkuList[j].skuName && req.orderSkuList[q]
                        .storeId == req.orderSkuList[j].storeId && req.orderSkuList[q].prodCatId == req
                        .orderSkuList[j].prodCatId && req.orderSkuList[q].batchNumber == req.orderSkuList[j]
                        .batchNumber) {
                        for (
                          let p = 0; p < req.orderSkuList[j].saleAttrCode.length; p++
                        ) {
                          if (
                            req.orderSkuList[j].saleAttrCode[p].attrName == '多组分' ||
                            req.orderSkuList[j].saleAttrCode[p].attrName == 'Multicomponent' ||
                            req.orderSkuList[j].saleAttrCode[p].attrName == '气体组分' ||
                            req.orderSkuList[j].saleAttrCode[p].attrName == 'Gas Components' ||
                            req.orderSkuList[j].saleAttrCode[p].attrName == '确认含量' ||
                            req.orderSkuList[j].saleAttrCode[p].attrName == 'Confirmed content'
                          ) {
                            req.orderSkuList[q].saleAttrCode.push(
                              req.orderSkuList[j].saleAttrCode[p]
                            );
                          }
                        }
                      }
                    }
                  }
                }
                req.orderSkuList[0].isTrue = 'true';
              });
              res.data.data.list.forEach((i) => {
                for (let q = 0; q < i.orderSkuList.length; q++) {
                  for (let j = q + 1; j < i.orderSkuList.length; j++) {
                    if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                      if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                        .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId &&
                        i.orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                        i.orderSkuList.splice(j, 1);
                      }
                    }
                  }
                }
              })
              res.data.data.list.forEach((i) => {
                for (let q = 0; q < i.orderSkuList.length; q++) {
                  for (let j = q + 1; j < i.orderSkuList.length; j++) {
                    if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                      if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                        .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId &&
                        i.orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                        i.orderSkuList.splice(j, 1);
                      }
                    }
                  }
                }
              })
              res.data.data.list.forEach((i) => {
                for (let q = 0; q < i.orderSkuList.length; q++) {
                  for (let j = q + 1; j < i.orderSkuList.length; j++) {
                    if (i.orderSkuList[q].remark == '1' && i.orderSkuList[j].remark == '1') {
                      if (i.orderSkuList[q].skuName == i.orderSkuList[j].skuName && i.orderSkuList[q].storeId == i
                        .orderSkuList[j].storeId && i.orderSkuList[q].prodCatId == i.orderSkuList[j].prodCatId &&
                        i.orderSkuList[q].batchNumber == i.orderSkuList[j].batchNumber) {
                        i.orderSkuList.splice(j, 1);
                      }
                    }
                  }
                }
              })
              this.order_list = res.data.data.list;
              this.page.total = res.data.data.total;
            }
          }
        ).finally(() => {
				  this.isLoading = false;
			  });
      },
      //订单详情
      ding_detail(e) {
        this.$router.push({
          path: '/detail_dingdan',
          query: {
            orderId: e.orderId,
          },
        });
      },
      // 立即确认
      lijiconfirm(e) {
        this.$confirm(this.$t('message.shortmessage-032'), this.$t('common.Confirmation'), {
          confirmButtonText: this.$t('button.Confirm'),
          cancelButtonText: this.$t('button.Cancel'),
          type: 'warning',
        }).then(() => {
           this.isLoading = true;
          get(
          'api/orderbasic/updateOrderConfirmStatus?orderId=' + e.orderId
          ).then((res) => get(
            'api/syncData/orderToErp?orderId=' + e.orderId
          )).then(res => post('api/wxMsgPush/sendOrderConfirmStatusWxMsg?orderId='+e.orderId+''))
          .finally(() => {
            this.getorder(this.currentPage);
          });
        });
      },
      //付款
      fukuan(e) {
        //openPay(e);
        this.$router.push({
          name: 'Zhuanzhang',
          params: {
            price: e.orderAmount,
          },
          query: {
            orderId: e.orderId,
            isBuy: false
          },
        });
      },
      fukuan2(e) {
        this.$router.push({
            name: 'Zhuanzhang',
            params: {
              price: this.price,
            },
            query: {
              orderId: e.orderNo,
              istrue: '1',
              isBuy:false,
              jifen:1
            },
          });
      },
      tuikuan(e) {
        this.$router.push({
          name: 'Tuihuosq',
          params: {
            skuId: e.skuId,
            orderId: e.orderId,
          },
        });
      },
      //确认收货
      shouhuo(e) {
        get('api/orderbasic/updateorderReceiv?orderId=' + e.orderId).then(
          (res) => {
            this.getorder(this.currentPage);
            // 验证订单是否已收货()
            // this.checkOrderStatus(e.orderId, 0);
          }
        );
      },
      //取消订单
      quxiao(e) {
        this.$confirm(this.$t('message.shortmessage-033'), this.$t('common.Confirmation'), {
          confirmButtonText: this.$t('button.Confirm'),
          cancelButtonText: this.$t('button.Cancel'),
          type: 'warning',
        }).then(() => {
          get('api/orderbasic/updateorder?orderId=' + e.orderId).then((res) => {
            this.getorder(this.currentPage);
          });
        });
      },
      pingjia(e) {
        this.$router.push({
          name: 'Pingjia',
          params: {
            skuId: e.skuId,
            orderId: e.orderId,
            batchNumber: e.batchNumber
          },
        });
      },
      //删除订单
      del(e) {
        this.$confirm(this.$t('message.shortmessage-034'), this.$t('common.Confirmation'), {
          confirmButtonText: this.$t('button.Confirm'),
          cancelButtonText: this.$t('button.Cancel'),
          type: 'warning',
        }).then(() => {
          this.isLoading = true;
          get('api/orderbasic/deleteOrderBasicById?orderId=' + e.orderId).then(
            (res) => {
              this.$message.success({
                message: this.$t('message.Successfully_deleted'),
              });
            }
          ).finally(() => {
              this.getorder(this.currentPage);
			    });
        });
      },
      // 申请发票
      applyInvoice(e) {
        // 1.验证订单发票开具是否已超时(超过30天不可开具发票，反之即可)
        get(
          'api/invoice/checkIsPrintInvoiceByOrderId?orderId=' +
          e.orderId.toString()
        ).then((res) => {
          // 订单不超过30天，执行开具发票
          if (res.data.data == false) {
            this.checkInvoice(e);
          } else {
            this.$message.warning({
              message: this.$t('message.shortmessage-035'),
            });
          }
        });
      },
      // 验证是否存在会员发票抬头
      checkInvoice(e) {
        // 2.验证是否存在会员发票抬头(若存在则直接开具发票，反之需执行新增发票抬头)
        get('api/invoice/checkIsInvoiceTitleByMemberId').then((res) => {
          // 新增发票抬头
          if (res.data.msg == '' || res.data.msg == null) {
            this.form.orderId = e.orderId;
            this.form.invType = '0';
            this.form.region = 'mx';
            this.form.ivcTitleType = '0';
            this.form.invTitle = '';
            this.form.registCode = '';
            this.form.registBank = '';
            this.form.bankAccount = '';
            this.form.registAddress = '';
            this.form.registPhone = '';
            this.dialogVisible = true;
          } else {
            // 根据订单状态是否确认收货前申请开票
            this.checkOrderStatus(e.orderId, res.data.msg);
          }
        });
      },
      // 保存发票抬头
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            post('api/invoice/saveInvoiceTitle', {
              invType: this.form.invType,
              region: this.form.region,
              ivcTitleType: this.form.ivcTitleType,
              invTitle: this.form.invTitle,
              companyName: this.form.invTitle,
              registCode: this.form.registCode,
              registBank: this.form.registBank,
              bankAccount: this.form.bankAccount,
              registAddress: this.form.registAddress,
              registPhone: this.form.registPhone,
            }).then((res) => {
              this.$message.success({
                message: this.$t('message.shortmessage-036')
              });
              this.dialogVisible = false;
              // 根据订单状态是否确认收货前申请开票
              this.checkOrderStatus(this.form.orderId, res.data.data);
            });
          } else {
            return false;
          }
        });
      },
      // 打印发票
      printInvoice(orderId, invId) {
        post('api/invoice/printInvoice', {
          invId: invId, // 发票抬头
          orderId: orderId, // 订单id
          invoiceType: '0', // 发票类型
        }).then((res) => {
          this.isLoading = false;
        });
      },
      // 验证订单是否已收货
      checkOrderStatus(orderId, invId) {
        get(
          'api/invoice/checkOrderStatusByOrderId?orderId=' +
          orderId +
          '&invId=' +
          invId
        ).then((res) => {
          // 订单没有收货，需确认收货才会开具发票
          if (res.data.data == false) {
            // 刷新订单列表(显示发票申请中)
            this.getorder(this.currentPage);
            this.$message.success({
              message: this.$t('message.fapiao-shortmessage-001'),
            });
          }
        });
      },
      // 查看发票
      showInvoice(item) {
        let src = item.orderInv.localUrl;
        if (src.indexOf('/') == 0 || src.indexOf('\\')) {
          src = src.substring(1);
        }
        window.open(baseURL + src, '_blank');
      },
      // 打开配件管理画面
      openAccessoriesList(item, res){
        // 赋值订单产品信息
        this.$refs.accessoriesForm.orderId = item.orderId;
        this.$refs.accessoriesForm.orderNo = item.orderNo;
        this.$refs.accessoriesForm.storeId = res.storeId;
        this.$refs.accessoriesForm.batchNumber = res.batchNumber;
        this.$refs.accessoriesForm.spuId = res.spuId;
        this.$refs.accessoriesForm.spuName = res.spuName;
        this.$refs.accessoriesForm.skuCount = res.skuCount
        this.$refs.accessoriesForm.companyName=item.companyName;
        this.$refs.accessoriesForm.initAccessoryList();
        this.$refs.accessoriesForm.isReplace=false;
        this.$refs.accessoriesForm.dialogFormVisible = true;
      }
    },
  };
</script>
<style lang="scss" scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 78px;
    line-height: 78px;
    text-align: center;
  }

  .avatar {
    width: 400px;
    height: 200px;
  }

  .company-info-wrapper {
    background-color: #f5f5f5;
  }

  .tishi {
    width: 90%;
    text-align: center;
    margin-top: 150px;
    font-size: 24px;
    color: rgb(139, 135, 135);
  }

  .right {
    width: 1006px;
    padding-top: 34px;
    padding-left: 27px;
    background: #fff;

    .spen {
      font-size: 26px;
      font-weight: 600;
      color: #616161;
    }

    .menu {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .daohang {
        font-size: 15px;
        color: #272727;
        margin-right: 25px;
        height: 30px;

        .ul {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0;
          width: 400px;

          li {
            list-style: none;
            cursor: pointer;

            &.router-link-exact-active.router-link-active {
              color: #3661fe;
            }
          }
        }
      }

      .search {
        margin-right: 150px;
        display: flex;

        input {
          border: 0;
          outline: none;
          border: 1px solid #a7a7a7;
          height: 37px;
          padding-left: 10px;
        }

        .fangdajing {
          width: 45px;
          height: 40px;
          border: 1px solid #a7a7a7;
          border-left: none;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }

    .fenye {
      margin-top: 50px;
      margin-bottom: 20px;
    }

    .top {
      width: 100%;
      height: 42px;
      line-height: 42px;
      background: #f5f5f5;
      display: flex;
      margin-top: 30px;

      .biaoti {
        font-size: 16px;
        color: #888;
        margin-left: 20px;

        .danhao {
          color: #666;
          font-weight: 800;
        }

        img {
          width: 23px;
          height: 23px;
          margin-left: 10px;
        }
      }

      .dianpu {
        cursor: pointer;
      }

      .mar {
        margin-left: 40px;
      }

      .kefu {
        display: flex;
        align-items: center;
      }
    }

    .bottom {
      padding-bottom: 20px;
      width: 100%;
      border-bottom: 1px solid #f5f5f5;
      display: flex;

      .pic {
        width: 180px;
        height: 136px;
        margin-top: 40px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .title1 {
        height: 100%;
        border-right: 1px solid #eaeaea;
        padding-right: 10px;
        width: 345px;

        .title {
          padding-top: 34px;
          display: flex;
          justify-content: space-between;

          .miaoshu {
            color: #333;
            width: 190px;
            margin-left: 10px;
            height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            cursor: pointer;
          }

          .shuliang {
            margin-left: 10px;
          }
        }

        .xiangsi {
          font-size: 14px;
          color: #9a9a9a;
          margin-top: 10px;
        }

        .shuxing {
          margin-left: 10px;
          font-size: 12px;
          color: #9a9a9a;
          /* margin-top: 10px; */
          display: flex;
        }
      }

      .tousu {
        width: 102px;
        border-right: 1px solid #eaeaea;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #333;
      }

      .price {
        width: 158px;
        border-right: 1px solid #eaeaea;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .jiage {
          font-size: 14px;
          color: #333;
        }

        .yunfei {
          color: #a0a0a0;
          font-size: 12px;
        }

        .fangshi {
          color: #a0a0a0;
          font-size: 12px;
        }
      }

      .zhuangtai {
        width: 130px;
        border-right: 1px solid #eaeaea;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #333;

        .xiangqing {
          margin-top: 5px;
          cursor: pointer;
        }

        .wuliu {
          color: #dc7413;
          margin-top: 5px;
          cursor: pointer;
        }

        .quxiao {
          color: #a0a0a0;
          margin-top: 5px;
        }
      }

      .pay {
        width: 136px;
        border-right: 1px solid #eaeaea;
        font-size: 12px;
        color: #333;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .liji {
          color: #fff;
          background: #1850ff;
          padding: 5px 10px;
          width: 85px;
          border-radius: 5px;
          margin: 0 auto;
          cursor: pointer;
          margin-top: 10px;
        }

        .liji1 {
          color: #fff;
          background: #ff902a;
          padding: 5px 10px;
          width: 85px;
          border-radius: 5px;
          margin: 0 auto;
          margin-top: 10px;
          cursor: pointer;
        }

        .daifu {
          cursor: pointer;
          margin-top: 5px;
        }

        .shachu {
          color: #fff;
          background: #ff902a;
          padding: 5px 10px;
          width: 85px;
          border-radius: 5px;
          margin: 0 auto;
          margin-top: 10px;
          cursor: pointer;
        }

        .quxiao {
          cursor: pointer;
          margin-top: 5px;
        }

        .queren {
          color: #fff;
          background: #42b983;
          padding: 5px 10px;
          width: 85px;
          border-radius: 5px;
          margin: 0 auto;
          cursor: pointer;
          margin-top: 10px;
        }

        .fapiaoshenqing {
          color: #fff;
          background: #42b983;
          padding: 5px 10px;
          width: 85px;
          border-radius: 5px;
          margin: 0 auto;
          cursor: pointer;
          margin-top: 10px;
        }

        .fapiaoshenqingzhong {
          color: #fff;
          background: #ff902a;
          padding: 5px 10px;
          width: 85px;
          border-radius: 5px;
          margin: 0 auto;
          margin-top: 10px;
          cursor: pointer;
        }

        .fapiaochakan {
          color: #fff;
          background: #1850ff;
          padding: 5px 10px;
          width: 85px;
          border-radius: 5px;
          margin: 0 auto;
          cursor: pointer;
          margin-top: 10px;
        }

        .goods-xinghao {
          width: 180px;
          padding-top: 15px;
          margin-left: 20px;

          .goods-xinghao-list {
            display: flex;
            margin-top: 5px;
            color: #9c9c9c;

            &-r {
              margin-left: 5px;
            }
          }
        }
      }
    }
  }
</style>